import { Icon, IconProps, IconSize } from '@bechtel/gds';
import styled, { css, keyframes } from 'styled-components';

export const spin = keyframes`
  {
    0% { transform: rotate(0deg); }
    50% { transform: rotate(180deg); }
    100% { transform: rotate(360deg); }
  }
`;

function getSizeStyle({ ...props }: IconProps) {
  switch (props.size) {
    case IconSize.LARGE:
      return css`
        ${({ theme }) => css`
          width: ${theme.spacings[800]};
          height: ${theme.spacings[800]};
        `}
      `;
    case IconSize.MEDIUM:
      return css`
        ${({ theme }) => css`
          width: ${theme.spacings[700]};
          height: ${theme.spacings[700]};
        `}
      `;
    case IconSize.SMALL:
      return css`
        ${({ theme }) => css`
          width: ${theme.spacings[500]};
          height: ${theme.spacings[500]};
        `}
      `;
    default:
      return css`
        ${({ theme }) => css`
          width: ${theme.spacings[500]};
          height: ${theme.spacings[500]};
        `}
      `;
  }
}

export const SpinnerIconStyled = styled(Icon)<IconProps>`
  animation: ${spin} 1s normal linear infinite;
  svg {
    height: auto;
    color: ${(props) => props.fillColor};
  }
  ${getSizeStyle}
`;
